'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/scrollbar';
import { VariantsEntity } from '@eliadmin/core/src/api/products/types/product-types';
import { cn } from '@eliadmin/core/src/utils/style-utils';

const VariantSwiper = ({ variants }: { variants: VariantsEntity[] }) => {
  return (
    <Swiper
      slidesPerView={3}
      spaceBetween={10}
      breakpoints={{
        580: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      }}
      scrollbar={{
        hide: true,
      }}
      modules={[Scrollbar]}
      className="mySwiper h-[140px] w-full"
    >
      {variants?.map((variant, index) => (
        <SwiperSlide key={index} className={cn('', 'ea-variant-slider')}>
          <Image
            src={variant?.images[0]?.url || '/images/placeholder.png'}
            fill
            alt={resolveImageAlt(variant?.images?.[0], 'Variant')}
            style={{ objectFit: 'cover' }}
            sizes="25vw"
            loading="lazy"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default VariantSwiper;
